import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { IntegrationActionData, IntegrationActionQuery } from './integration-action.interface';
import { SocketIntegrationAction } from '../../layout/right-sidebar/components/integration-instagram/integration.interface';
import { CHANNEL_TYPE, CHANNEL_TYPES_OBJECT } from '../../../enum/constants';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-integration-action',
  templateUrl: './integration-action.component.html',
  styleUrls: ['./integration-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class IntegrationActionComponent implements OnInit {
  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly translate: TranslateService,
  ) {}

  protected readonly homeUrl: string = `${window.location.protocol}//${environment.web_url}`;
  private query!: IntegrationActionQuery;
  protected integrationActionData!: IntegrationActionData;

  ngOnInit(): void {
    this.parseQuery().then();
  }

  protected onNext() {
    window.location.href = this.homeUrl;
  }

  private async parseQuery() {
    const query = this.activatedRoute.snapshot.queryParams;

    this.query = {
      action: query['action'] ? query['action'] : SocketIntegrationAction.UNKNOWN,
      integration: query['integration'] ? query['integration'] : CHANNEL_TYPE.UNKNOWN,
    } as IntegrationActionQuery;

    await this.initIntegrationActionObj();
  }

  private async initIntegrationActionObj() {
    const integrationData = {
      icon: this.getIntegrationIcon(),
      actionIcon: '',
      title: '',
    } as IntegrationActionData;

    switch (this.query.action) {
      case SocketIntegrationAction.SUCCESS: {
        integrationData.title = this.translate.instant('account_connection_success', {
          channel: await this.getChannelString(),
        });
        integrationData.actionIcon = '/assets/svgs/integrations/ic_success.svg';
        break;
      }
      case SocketIntegrationAction.PAGES_AVAILABLE: {
        integrationData.title = this.translate.instant('select_facebook_page_in_crm');
        integrationData.actionIcon = '/assets/svgs/integrations/ic_success.svg';
        break;
      }
      case SocketIntegrationAction.FAILED: {
        integrationData.title = this.translate.instant('account_connected_failed', {
          channel: await this.getChannelString(),
        });
        integrationData.actionIcon = '/assets/svgs/integrations/ic_error.svg';
        break;
      }
      default: {
        integrationData.title = this.translate.instant('account_connected_unknown', {
          channel: await this.getChannelString(),
        });
        integrationData.actionIcon = '/assets/svgs/integrations/ic_unknown.svg';
        break;
      }
    }
    this.integrationActionData = integrationData;
  }

  private getChannelString(): Promise<string> {
    const key = `channels_type.${this.query.integration.toLowerCase()}`;
    return firstValueFrom(this.translate.get(key));
  }

  private getIntegrationIcon(): string {
    console.log(this.query.integration);
    const icon = CHANNEL_TYPES_OBJECT[this.query.integration]?.img_url;
    if (icon === 'UNKNOWN') return '';
    return icon;
  }
}
